
export const MAPPING_PROPS_NUMERIC_4X = [
    'StartWeight',
    'EndWeight',
    'AverageWeightOfBoughtAnimals',
    'AverageWeightOfSoldAnimals',
    'DailyLiveWeightGain'
];

export const REPORT_STATUS_OPTIONS = [
    { key: 'Blank', value: [0] },
    { key: 'Missing Data', value: [1] },
    { key: 'Incomplete', value: [ 2, 3, 4] },
    { key: 'Under Validation', value: [5, 6] },
    { key: 'Validated', value: [7] },
    { key: 'Valid (not in benchmarks)', value: [8] },
    { key: 'Invalid Data', value: [9] },
    { key: 'Finalised (not validated)', value: [10] },
]

export const LICENSE_OPTIONS = [
    { key: 'Free', value: 0 },
    { key: 'Paid', value: 1 },
]


